import type { FC } from 'react';
import Avatar from '@/components/UI/Avatar/Avatar';

interface ApiAvatarProps {
  className?: string;
  testId?: string;
}

/**
 * Avatar shown in place of a UserAvatar when a record has no recording user
 * (for example observations created via the external API). Renders a fixed
 * "</>" label, revealing an "API" tooltip on hover, and shares the same
 * background color as a real UserAvatar.
 */
const ApiAvatar: FC<ApiAvatarProps> = ({ className = '', testId = 'api-avatar' }) => (
  <span data-testid={testId}>
    <Avatar tooltip="API" bgColorClass="bg-dark-gray" className={className}>
      {'</>'}
    </Avatar>
  </span>
);

export default ApiAvatar;
